<template>
  <data-card color="primary" :title="$tc('administration.costCenterImport.title', 2)">
    <div style="background-color: white" class="pa-2">
      {{$t('administration.costCenterImport.description')}}
      <br><br>
      <v-btn
        v-if="this.isUserAdministrator"
        :loading="isDataUpdating"
        style="margin-right: 100px"
        @click="confirmCostCenterImport"
        >
        {{$t('administration.costCenterImport.startImport')}}
        <v-icon right color="red">refresh</v-icon>
      </v-btn>
    </div>
  </data-card>
</template>

<script>
import { Api } from '@/api/apiAccess'
import { mapGetters } from 'vuex'
import { confirmMixin, snackBarMixin, pageTitleMixin } from '@/mixins/mixins'

export default {
  mixins: [
    confirmMixin,
    snackBarMixin,
    pageTitleMixin
  ],
  data () {
    return {
      isDataUpdating: false
    }
  },
  computed: {
    ...mapGetters(['isUserAdministrator'])
  },
  methods: {
    confirmCostCenterImport () {
      this.$confirm(this.$t('administration.costCenterImport.importCostCenterConfirm'), { title: this.$t('administration.costCenterImport.importCostCenter'), focusFalseButton: true })
        .then((r) => {
          if (r) {
            this.importCostCenters()
          }
        })
    },
    importCostCenters () {
      this.isDataUpdating = true

      let ep = Api.CostCenter
      ep.costCenterImportCostCentersFromSage()
        .then(r => {
          this.$nextTick(() => {
            this.showStatusMessage(this.$t('administration.costCenterImport.importSuccess'))
          })
        })
        .finally(() => {
          this.isDataUpdating = false
        })
    }
  }
}
</script>
